import { Welcome } from "./styles";

const Component = ({ children }) => {
  return <Welcome>{children}</Welcome>;
};

export default Component;
